<template>
    <div>
        <!--==========================
            Hero Section
        ============================-->
        <section id="hero">
            <div class="hero-container">
                <h1>RightSpec<sup>&reg;</sup> Cross Reference</h1>
                <!--<h2>RightSpec<sup>&reg;</sup> Competitor Cross Reference Guide</h2>-->
            </div>
        </section>
        <!-- #hero -->

        <modal-disclaimer />

        <main id="main">
            <!--==========================
                About Section
            ============================-->

            <section id="about" data-aos="fade-in">
                <div class="container">
                    <div class="row section-container">

                        <div class="col content">
                            <h2 class="title">
                                RightSpec<sup>&reg;</sup> Competitor Cross Reference Guide
                            </h2>
                            <p>
                                When you need to find the right replacement for an existing Bradford White model or for another manufacturer's model, the RightSpec<sup>&reg;</sup> Cross-Reference Guide is the place to start. Simply choose the brand and then the model number you are replacing. The cross reference tool will automatically display the appropriate Bradford White model along with side-by-side specifications.
                            </p>

                            <warning-notes />
                        </div>
                    </div>
                </div>
            </section>

            <section id="system-settings" data-aos="fade-up" data-aos-delay="150" class="mt-3">
                <div class="container">
                    <div class="row additional-load">
                        <div class="col-lg-12">

                            <div class="box">
                                <div class="icon"><a><i class="fa fa-sliders-h"></i></a></div>
                                <h4 class="title"><a>Model Selection</a></h4>
                                <div class="box-content">
                                    <inputs-model-select :allManufacturers="false"
                                                         :showResults.sync="showResults"
                                                         @getInputValues="getXrefSolution" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="results" class="mb-5">
                <div v-if="getSolutionAsyncPending" class="text-center mt-5">
                    <b-spinner variant="light" style="width: 3rem; height: 3rem;" label="loading..."></b-spinner>
                </div>

                <section v-if="showResults" data-aos="fade-up" class="mt-5">
                    <div class="container">
                        <div class="text-right justify-content-end align-items-center mb-2">
                            <span class="layout-caption text-sm mr-2">PDF</span>
                            <b-button class="btn btn-sm btn-layout"
                                      :disabled="getPdfAsyncPending"
                                      @click="getPDF()">
                                <i v-if="getPdfAsyncPending" class="fa fa-spinner fa-spin"></i>
                                <i v-else class="mdi mdi-file-pdf "></i>
                            </b-button>
                        </div>
                    </div>
                </section>


                <xref-results :showResults="showResults"
                              :showError="invalidHttpStatusCode(getSolutionAsyncStatusCode)"
                              :results="getSolutionAsyncData" />
            </section>
        </main>
    </div>
</template>

<script>

    import xrefResults from '@/components/XRefResults'
    import InputsModelSelect from '@/components/InputsModelSelect.vue'
    import ModalDisclaimer from '@/components/ModalDisclaimer.vue'
    import WarningNotes from '@/components/WarningNotes.vue'

    import { mapState } from 'vuex'

    export default {

        name: 'home',
        components: {
            xrefResults,
            InputsModelSelect,
            ModalDisclaimer,
            WarningNotes,
        },
        methods: {
            async getPDF() {
                await this.$store.dispatch('getPDF', this.inputData)
            },
            async getXrefSolution(payload) {
                this.showResults = false
                this.inputData = payload
                await this.$store.dispatch('getSolutionData', payload)
            },
        },
        computed: {
            ...mapState([
                'getSolutionAsyncPending',
                'getSolutionAsyncData',
                'getSolutionAsyncStatusCode',
                'getPdfAsyncPending',
                'getPdfAsyncData',
                'getPdfAsyncStatusCode'
            ]),

        },
        data() {
            return {
                showResults: false,
                inputData: null,
            }
        },

        watch: {

            getSolutionAsyncData(newValue) {
                if (newValue && newValue.length > 0)
                    this.showResults = true
                else
                    this.showResults = false

            }
        }
    }
</script>

<style scoped lang="scss">
    @import '~@/styles/scss/variables';

    .btn-layout {
        color: #5e5e5e;
        padding: 0 5px;
        margin: 0;
        font-size: 17px;
        border: 1px solid #d3d3d3;
        border-radius: 3px;
        background-color: #F0F0F0;
    }

        .btn-layout:hover {
            color: #fff;
            background-color: #086089;
            border-color: #086089;
            border-radius: 3px;
        }
</style>
